'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('interface-datastore'),
    Adapter = _require.Adapter,
    utils = _require.utils;

var map = utils.map;
/**
 * A datastore shim, that wraps around a given datastore, changing
 * the way keys look to the user, for example namespacing
 * keys, reversing them, etc.
 */

var KeyTransformDatastore = /*#__PURE__*/function (_Adapter) {
  _inherits(KeyTransformDatastore, _Adapter);

  var _super = _createSuper(KeyTransformDatastore);

  function KeyTransformDatastore(child, transform) {
    var _this;

    _classCallCheck(this, KeyTransformDatastore);

    _this = _super.call(this);
    _this.child = child;
    _this.transform = transform;
    return _this;
  }

  _createClass(KeyTransformDatastore, [{
    key: "open",
    value: function open() {
      return this.child.open();
    }
  }, {
    key: "put",
    value: function put(key, val, options) {
      return this.child.put(this.transform.convert(key), val, options);
    }
  }, {
    key: "get",
    value: function get(key, options) {
      return this.child.get(this.transform.convert(key), options);
    }
  }, {
    key: "has",
    value: function has(key, options) {
      return this.child.has(this.transform.convert(key), options);
    }
  }, {
    key: "delete",
    value: function _delete(key, options) {
      return this.child.delete(this.transform.convert(key), options);
    }
  }, {
    key: "batch",
    value: function batch() {
      var _this2 = this;

      var b = this.child.batch();
      return {
        put: function put(key, value) {
          b.put(_this2.transform.convert(key), value);
        },
        delete: function _delete(key) {
          b.delete(_this2.transform.convert(key));
        },
        commit: function commit(options) {
          return b.commit(options);
        }
      };
    }
  }, {
    key: "query",
    value: function query(q, options) {
      var _this3 = this;

      return map(this.child.query(q, options), function (e) {
        e.key = _this3.transform.invert(e.key);
        return e;
      });
    }
  }, {
    key: "close",
    value: function close() {
      return this.child.close();
    }
  }]);

  return KeyTransformDatastore;
}(Adapter);

module.exports = KeyTransformDatastore;